<template>
    <div>
        <div class="hint cursor-pointer" :class="[showHint ? 'show' : '']" @click="toggleShowHint()">
            ?
            <div class="hint-text cursor-text" v-html="hint"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "HintComponent",
    props:{
        hint: { type: String, default: "" }
    },
    data: function () {
        return {
            showHint: false
        };
    },
    methods: {
        toggleShowHint(){
            this.showHint = !this.showHint;
        }
    }
};
</script>
